/**
 * 2019-04-13
 * handan
 * 查询结果失败，免费重查
 */

import React, { Component } from 'react'
import { connect } from "react-redux";
import { getFreeInquiry } from "../../models";
import mergeData from "../../utils/mergeData";

class ResultError extends Component{
  constructor(props){
    super(props)
    this.onClickInquiry = this.onClickInquiry.bind(this);
  }
  render(){
    const { data = {} } = this.props;
    let params = {
      batchId: data.batchId,
      itemId: data.itemId,
      realName: data.realName,
      idNum: data.idNum,
      id: data.record,
    }
    return (
      <div className="">
        <div className="resultHide-wrap">
          <div className="checkbox"></div>
          <div className="content">
            <p>{data.itemName} {data.itemId === 11 && <img className="tag"  src='//pic1.58cdn.com.cn/nowater/cxnomark/n_v26a916df50aba4669a2a6f2146db56563.png'/>} </p>
            <span>{data.secDesc}</span>
            <div className={"bg " + data.className}></div>
          </div>
          <div className="right queryFails">
            <p className="prompt">
              <span>抱歉，查询失败！</span><br />
              <em>联系客服：10105858</em>
            </p>
            <button className="btn2" onClick={this.onClickInquiry}>免费重查</button>
          </div>
        </div>
      </div>
    )
  }
  onClickInquiry(){
    const { data = {}, batchId, setLoadingState, setVerifyDataList, verifyDataList=[], getDataCallback } = this.props;
    let params = {
      batchId,
      orderId: data.orderId,
      recordId: data.record,
    }
    setLoadingState(true)
    getFreeInquiry(params).then(()=>{
      getDataCallback();
      setLoadingState(false)
      // let newArr = [...verifyDataList]
      // let newData = mergeData(newArr,data)
      // console.log(data);
      // setVerifyDataList(newData);
    }).catch(()=>{})
  }
}

const mapState = (store)=>{
  return {
    verifyDataList: store.verifyResult.verifyDataList,
  }
}
const mapDispatch = (dispatch)=>{
  return {
    setVerifyDataList(data){
      dispatch({
        type: "setVerifyDataList",
        data,
      })
    },
    setLoadingState(data){
      dispatch({
        type: "setLoadingState",
        data
      })
    },
  }
}
export default connect(mapState,mapDispatch)(ResultError);